module.exports = __webpack_public_path__ + "img/中通星联.49339d58.png";